/**
 * Ping na cena (`docs/spec/table-media.md`, o `PingerEngine` do original): as contas, em funções
 * puras. O desenho fica no `SceneModule`.
 */

/** Quanto o ping fica na tela (ms) e até onde as ondas se abrem (raio, em células). */
export const PING_SHOW_MS = 3000;
export const PING_RADIUS = 2.8;
/** A cor do ping de quem não tem cor (a do original, CornflowerBlue). */
export const PING_COLOR = '#6495ed';

/** Distância da seta até a borda da vista (px). */
const EDGE_MARGIN = 32;

/**
 * Ping fora da vista: o ponto na borda (recuado `margin` px) na reta do centro da vista até o
 * ping, e o ângulo (graus, 0 para a direita, sentido do relógio) para a seta apontar para ele.
 * `null` se o ping está na vista ou se a vista não tem tamanho.
 */
export function pingEdge(sx: number, sy: number, w: number, h: number, margin = EDGE_MARGIN): { x: number; y: number; angle: number } | null {
  if (w <= margin * 2 || h <= margin * 2) return null;
  if (sx >= 0 && sy >= 0 && sx <= w && sy <= h) return null;
  const cx = w / 2;
  const cy = h / 2;
  const dx = sx - cx;
  const dy = sy - cy;
  const t = Math.min(dx ? (cx - margin) / Math.abs(dx) : Infinity, dy ? (cy - margin) / Math.abs(dy) : Infinity);
  return { x: cx + dx * t, y: cy + dy * t, angle: (Math.atan2(dy, dx) * 180) / Math.PI };
}
